import { createSlice, isPending, isRejected } from '@reduxjs/toolkit';
import { showApiErrors } from '@/utils';
import { getFaqChannels } from './actionCreators';
import { SLICE_NAME, FaqChannelsState, initialState } from './models';

export const faqChannelsSlice = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getFaqChannels.fulfilled, (state: FaqChannelsState, action) => {
        state.isLoading = false;
        state.channels = action.payload.channels;
      })
      .addMatcher(isPending(getFaqChannels), (state: FaqChannelsState) => {
        state.isLoading = true;
        state.error = null;
      })
      .addMatcher(isRejected(getFaqChannels), (state: FaqChannelsState, action) => {
        const { error } = action;

        state.isLoading = false;
        state.error = error;
        showApiErrors(error);
      });
  },
});
